<kendo-card width="auto">
  <kendo-card-body class="banner">
    <kendo-stacklayout orientation="horizontal" [gap]="20" [align]="{ horizontal: 'center', vertical: 'middle' }">
      <div>
        <unity-icon-shared size="xxxlarge" [icon]="$icon()" />
      </div>
      <div><ng-content /></div>
    </kendo-stacklayout>
  </kendo-card-body>
</kendo-card>
